export const devEnvFlag = ['dev', 'development', 'sandbox'].includes(
  process.env.REACT_APP_BUILD_ENV || process.env.REACT_APP_ALP_ENV || '',
);

export const testEnvFlag = process.env.NODE_ENV === 'test';
